export enum providerActionsTypes {
    GET_PROVIDER_REQUEST = 'GET_PROVIDER_REQUEST',
    GET_PROVIDER_SUCCESS = 'GET_PROVIDER_SUCCESS',
    GET_PROVIDER_FAILURE = 'GET_PROVIDER_FAILURE',
  }